import type { Attendances, Attendance } from './vuex';

export default {
  attendances: { attendances: [], participants: [] } as Attendances,
  attendance: null as null | Attendance,
};
